<template>
  <form action="" method="post">
    <div v-if="state === 'form'" class="p-contactNotice">
      <ul class="p-contactNotice__edit">
        <li>
          <p class="ja">
            弊社へのご質問・お問い合わせは、以下のフォームに必要事項をご入力の上、送信してください。<br />
            採用についてのお問い合わせは、下記ページをご確認ください。<br />
          </p>
        </li>
        <li>
          <btn-recruit
          text-en="RECRUIT"
          text-ja="採用についてのお問い合わせはこちらから"
          >
          </btn-recruit>
        </li>
        <li>
          <p>
            <span class="isRed">＊</span>は必須項⽬です。<br />
            If you have any questions or inquiries, please fill out and send the form below.<br />
            <span class="isRed">Asterisk ( * ) </span>are required items.
          </p>
        </li>
      </ul>
    </div>

    <div id="p-contactHead" class="p-contactHead">
      <ul class="p-contactHead__process">
        <li :class="{'isCurrent': state === 'form'}">必須項⽬の⼊⼒</li>
        <li :class="{'isCurrent': state === 'confirm'}">⼊⼒内容の確認</li>
        <li :class="{'isCurrent': state === 'complete'}">送信完了</li>
      </ul>
    </div>

    <transition name="p-contactFrm">
    <div v-if="state === 'form'" class="p-contactFrm">
      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['contactType']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">お問合せの種類を選択してください<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">Type of inquiry</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="contact-type">
            <!-- span v-show="contactType === ''" class="isRequired">お問い合わせの種類を選択してください</span -->
          </label>
          <p class="p-contactFrm__inputWrap__selectValue">{{contactType}}</p>
          <div class="p-contactFrm__inputWrap__btn">
            <span class="p-contactFrm__inputWrap__btnArrow"></span>
          </div>
          <select id="contact-type" v-model="contactType" name="contact-type" @change="changeSelect">
            <option value=""></option>
            <option value="新規案件のご依頼・ご相談">新規案件のご依頼・ご相談</option>
            <option value="弊社クリエイターに関するお問い合わせ">弊社クリエイターに関するお問い合わせ</option>
            <option value="広報(取材、作品掲載など）に関するお問い合わせ">広報(取材、作品掲載など）に関するお問い合わせ</option>
            <option value="Inquiries from overseas">Inquiries from overseas</option>
            <option value="その他">その他</option>
          </select>
        </div>
        <p v-show="errors['contactType']" class="p-contactFrm__inputError">{{errors['contactType']}}</p>
        <p class="p-contactFrm__inputNote">※採用については<a href="/recruit/">RECRUITページ</a>からお問い合わせください</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['company1']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">会社名</p>
          <p class="p-contactFrm__inputGuide__en">Company name</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="input-company">
            <!-- span v-show="showPlaceholder('company1')">会社名</span -->
          </label>
          <input id="input-company" v-model="company1" type="text" name="company1" @focus="inputFocus('company1')" @blur="inputBlur('company1')" />
        </div>
        <p v-show="errors['company1']" class="p-contactFrm__inputError">{{errors['company1']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['company2']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">部署／役職</p>
          <p class="p-contactFrm__inputGuide__en">Department／Position</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="input-company2">
            <!-- span v-show="showPlaceholder('company2')">部署／役職</span -->
          </label>
          <input id="input-company2" v-model="company2" type="text" name="company2" @focus="inputFocus('company2')" @blur="inputBlur('company2')" />
        </div>
        <p v-show="errors['company2']" class="p-contactFrm__inputError">{{errors['company2']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['name']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">お名前<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">Name</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="input-name">
             <!-- span v-show="showPlaceholder('name')" class="isRequired">お名前</span -->
          </label>
          <input id="input-name" v-model="name" type="text" name="name" @focus="inputFocus('name')" @blur="inputBlur('name')" />
        </div>
        <p v-show="errors['name']" class="p-contactFrm__inputError">{{errors['name']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['email']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">メールアドレス<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">Email address</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="input-email">
             <!-- span v-show="showPlaceholder('email')" class="isRequired">メールアドレス</span -->
          </label>
          <input id="input-email" v-model="email" type="email" name="email" @focus="inputFocus('email')" @blur="inputBlur('email')" />
        </div>
        <p v-show="errors['email']" class="p-contactFrm__inputError">{{errors['email']}}</p>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half" :class="{'p-contactFrm__input--error': errors['tel']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">電話番号<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">Phone number</p>
        </div>
        <div class="p-contactFrm__inputWrap">
          <label for="input-tel">
            <!-- span v-show="showPlaceholder('tel')" class="isRequired">電話番号</span -->
          </label>
          <input id="input-tel" v-model="tel" type="text" name="tel" @focus="inputFocus('tel')" @blur="inputBlur('tel')" />
        </div>
        <p v-show="errors['tel']" class="p-contactFrm__inputError">{{errors['tel']}}</p>
      </div>

      <!-- ピクスを知ったきっかけ -->
      <div 
        v-show="contactType==='新規案件のご依頼・ご相談'" class="p-contactFrm__input p-contactFrm__input" 
        :class="{'p-contactFrm__input--error': errors['know'] || errors['know_search'] || errors['know_how']}"
      >
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">ピクスを知ったきっかけ<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">How did you know about P.I.C.S.</p>
        </div>
        <div class="p-contactFrm__checks">
          <ul>
            <template v-for="k in know_defaults">
              <li v-if="k==='インターネットで検索して'">
                <label><input type="radio" name="know" v-model="know" :value="k">{{ k }}</label>
                <div class="input_option">
                  <input 
                  :class="{'is-disable': know !== k }"
                  type="text" 
                  name="know_search" 
                  v-model="know_search"
                  value="" 
                  placeholder="検索キーワードを入力してください"
                  >
                </div>
                <p v-show="errors['know_search']" class="p-contactFrm__inputError">{{errors['know_search']}}</p>
              </li>
              <li v-else-if="k==='その他きっかけ'">
                <label><input type="radio" name="know" v-model="know" :value="k">{{ k }}</label>
                <div class="input_option">
                  <input 
                  :class="{'is-disable': know !== k }"
                  type="text" 
                  name="know_how" 
                  v-model="know_how" 
                  value="" 
                  placeholder="その他きっかけを詳しく入力してください"
                  >
                </div>
                <p v-show="errors['know_how']" class="p-contactFrm__inputError">{{errors['know_how']}}</p>
              </li>
              <li v-else><label><input type="radio" name="know" v-model="know" :value="k">{{ k }}</label></li>
            </template>
          </ul>
        </div>
        <p v-show="errors['know']" class="p-contactFrm__inputError">{{errors['know']}}</p>
      </div>
      <!-- /ピクスを知ったきっかけ -->

      <div class="p-contactFrm__input" :class="{'p-contactFrm__input--error': errors['message']}">
        <div class="p-contactFrm__inputGuide">
          <p class="p-contactFrm__inputGuide__ja">お問い合わせ内容<span>＊</span></p>
          <p class="p-contactFrm__inputGuide__en">Description</p>
        </div>
        <div class="p-contactFrm__inputWrap p-contactFrm__inputWrap--ta">
          <label for="textarea-message">
            <!-- span v-show="showPlaceholder('message')" class="isRequired">お問い合わせ内容</span -->
          </label>
          <textarea id="textarea-message" v-model="message" name="message" @focus="inputFocus('message')" @blur="inputBlur('message')"></textarea>
        </div>
        <p v-show="errors['message']" class="p-contactFrm__inputError">{{errors['message']}}</p>
      </div>

      <div v-show="!isOverseas" class="p-contactFrm__input p-contactFrm__input--agree" :class="{'p-contactFrm__input--error': errors['agree']}">
        <div class="p-contactFrm__agree">
          <input id="input-agree" v-model="agree" type="checkbox" name="agree">
          <label @click="checkAgree">
            <span class="p-contactFrm__agree__check" :class="{'isChecked': this.agree}"></span>
            <span class="p-contactFrm__agree__text">「<a :href="`${assets_path}pdf/pp-contact.pdf`" target="_blank">個人情報の取り扱いについて</a>」をご確認頂き、同意の上お問い合わせください。</span>
          </label>
        </div>
        <p v-show="errors['agree']" class="p-contactFrm__inputError p-contactFrm__inputError--center">{{errors['agree']}}</p>
      </div>

      <div class="p-contactFrm__btnOuter">
        <div class="p-contactFrm__btn">
          <btn-submit
            textEn="CONFIRM"
            textJa="送信内容を確認する"
            bgColor="white"
            @click.native="onConfirm"
          >
          </btn-submit>
        </div>
      </div>
    </div>

    <div v-if="state === 'confirm'" class="p-contactFrm">
      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>お問合せの種類 <br class="u-none-b--sp"><span>Type of inquiry</span></dt>
          <dd>{{contactType}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>会社名 <br class="u-none-b--sp"><span>Company name</span></dt>
          <dd>{{company1}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>部署／役職 <br class="u-none-b--sp"><span>Department／Position</span></dt>
          <dd>{{company2}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>お名前 <br class="u-none-b--sp"><span>Name</span></dt>
          <dd>{{name}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>メールアドレス <br class="u-none-b--sp"><span>Email address</span></dt>
          <dd>{{email}}</dd>
        </dl>
      </div>

      <div class="p-contactFrm__input p-contactFrm__input--half">
        <dl class="p-contactFrm__inputResult">
          <dt>電話番号 <br class="u-none-b--sp"><span>Phone number</span></dt>
          <dd>{{tel}}</dd>
        </dl>
      </div>

      <!-- ピクスを知ったきっかけ -->
      <div v-show="contactType==='新規案件のご依頼・ご相談'" class="p-contactFrm__input">
        <dl class="p-contactFrm__inputResult">
          <dt>ピクスを知ったきっかけ <br class="u-none-b--sp"><span>How did you know about P.I.C.S.</span></dt>
          <dd>{{know}}</dd>
          <dd>{{know_search}}{{know_how}}</dd>
        </dl>
      </div>
      <!-- /ピクスを知ったきっかけ -->

      <div class="p-contactFrm__input p-contactFrm__input--bottom">
        <dl class="p-contactFrm__inputResult">
          <dt>お問い合わせ内容 <br class="u-none-b--sp"><span>Description</span></dt>
          <dd><pre>{{message}}</pre></dd>
        </dl>
      </div>

      <div class="p-contactFrm__btn">
        <div class="p-contactFrm__btnBack">
          <btn-submit
            textEn="BACK"
            textJa="戻る"
            bgColor="black"
            @click.native="onBack"
          >
          </btn-submit>
        </div>
        <div class="p-contactFrm__btnSubmit">
          <btn-submit
            textEn="ENTRY"
            textJa="送信する"
            bgColor="white"
            @click.native="onSubmit"
          >
          </btn-submit>
        </div>
      </div>
    </div>

    <div v-if="state === 'complete'" class="p-contactComp">
      <h1>お問い合わせいただきありがとうございす。<br />お問い合わせを受け付けました。<br />Your Inquiries has been received.<br />Thank you.</h1>
      <p>折り返し、担当者よりご連絡いたしますので、<br />
        恐れ入りますが、しばらくお待ちください。</p>
      <p>なお、ご入力いただいたメールアドレス宛に受付完了メールを配信しております。<br />
        完了メールが届かない場合、処理が正常に行われていない可能性があります。<br />
        大変お手数ですが、再度お問い合わせの手続きをお願い致します。</p>
      <div class="p-contactComp__btn">
        <btn-square
          text="TOPページ"
          url="/"
          bgColor="black"
          isAttached="off"
        ></btn-square>
      </div>
    </div>
    </transition>
  </form>
</template>

<script>
import { assets_path } from '@/_modules/utils/variables'
import axios from 'axios';
import store from '@/_modules/stores';
import BtnSubmit from '@/_components/btn-submit.vue';
import BtnSquare from '@/_components/btn-square.vue';
import BtnRecruit from '@/_components/btn-recruit.vue';
import validator from 'validator';
import {gsap, TweenMax, Cubic, ScrollToPlugin} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

export default {
  components: {
    BtnSubmit,
    BtnSquare,
    BtnRecruit
  },
  data() {
    return {
      assets_path: assets_path,
      state: 'form',
      isSubmit: false,
      isOverseas: false,
      errorFlg: false,
      errors: {},
      placeholder: {
        contactType: false,
        company1: false,
        company2: false,
        name: false,
        email: false,
        tel: false,
        message: false,
      },
      contactType: '',
      company1: '',
      company2: '',
      name: '',
      email: '',
      tel: '',
      message: '',

      know: '',
      know_search: '',
      know_how: '',

      agree: false,
      compUrl: '/contact-complete/',

      know_defaults: [
        'インターネットで検索して',
        '他媒体などで制作実績(クレジットなど)を見て',
        'お知り合いからのご紹介',
        '過去お取引あり',
        'その他きっかけ'
      ]
    }
  },
  store,
  computed: {
    showPlaceholder: function() {
      return function(name) {
        return !this.placeholder[name];
      }
    }
  },
  watch: {
    // お問い合わせの種類の選択した場合
    contactType(newValue, oldValue) {
      if (newValue !== "新規案件のご依頼・ご相談") {
        this.know = '';
        this.know_search = '';
        this.know_how = '';
      }
    },
    // ピクスを知ったきっかけを選択した場合
    know(newValue, oldValue) {
      if (newValue !== 'インターネットで検索して') {
        this.know_search = '';
      }
      if (newValue !== 'その他きっかけ') {
        this.know_how = '';
      }
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm() {
      // エラー情報をリセット
      this.errorFlg = false;
      this.errors = {
        contactType: '',
        company1: '',
        company2: '',
        name: '',
        email: '',
        tel: '',
        message: '',
        agree: '',
        know: '',
        know_search: '',
        know_how: '',
      };

      // お問い合わせの種類
      if (validator.isEmpty(this.contactType, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['contactType'] = 'お問合せの種類が選択されていません';
      }

      // 会社名
      if (!validator.isEmpty(this.company1, {ignore_whitespace: true})) {
        if (!validator.isLength(this.company1, {min: 0, max: 100})) {
          // 文字数超え
          this.errorFlg = true;
          this.errors['company1'] = '会社名は100文字以下で入力してください';
        }
      }

      // 部署／役職
      if (!validator.isEmpty(this.company2, {ignore_whitespace: true})) {
        if (!validator.isLength(this.company2, {min: 0, max: 100})) {
          // 文字数超え
          this.errorFlg = true;
          this.errors['company2'] = '部署／役職は100文字以下で入力してください';
        }
      }

      // お名前
      if (validator.isEmpty(this.name, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['name'] = 'お名前が入力されていません';
      } else if (!validator.isLength(this.name, {min: 0, max: 100})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['name'] = 'お名前は100文字以下で入力してください';
      }

      // メールアドレス
      if (validator.isEmpty(this.email, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスが入力されていません';
      } else if (!validator.isEmail(this.email)) {
        // メールアドレスが正しくない
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスが正しくありません';
      } else if (!validator.isLength(this.email, {min: 0, max: 1000})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['email'] = 'メールアドレスは1000文字以下で入力してください';
      }

      // 電話番号
      if (validator.isEmpty(this.tel, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['tel'] = '電話番号が入力されていません';
      } else if (!validator.isLength(this.tel, {min: 0, max: 30})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['tel'] = '電話番号は30文字以下で入力してください';
      }

      // お問い合わせ内容
      if (validator.isEmpty(this.message, {ignore_whitespace: true})) {
        // 未入力
        this.errorFlg = true;
        this.errors['message'] = 'お問い合わせ内容が入力されていません';
      } else if (!validator.isLength(this.message, {min: 0, max: 5000})) {
        // 文字数超え
        this.errorFlg = true;
        this.errors['message'] = 'お問い合わせ内容は5000文字以下で入力してください';
      }

      // 同意
      if (!this.isOverseas && !this.agree) {
        // 未入力
        this.errorFlg = true;
        this.errors['agree'] = '「個人情報の取り扱いについて」をご確認頂き、同意の上お問い合わせください。';
      }



      ///// ピクスを知ったきっかけ
      if (this.contactType === '新規案件のご依頼・ご相談') {
        if (validator.isEmpty(this.know)) {
          this.errorFlg = true;
          this.errors['know'] = 'ピクスを知ったきっかけが選択されていません';
        } else if (this.know === 'インターネットで検索して') {
          if (validator.isEmpty(this.know_search)) {
            this.errorFlg = true;
            this.errors['know_search'] = '検索キーワードを入力してください';
          }
        } else if (this.know === 'その他きっかけ') {
          if (validator.isEmpty(this.know_how)) {
            this.errorFlg = true;
            this.errors['know_how'] = 'その他きっかけを詳しく入力してください';
          }
        }
      }
      /////



      // 上にスクロール
      this.gotoHead();

      if (!this.errorFlg) {
        this.state = 'confirm';
      }
    },
    onBack() {
      this.gotoHead();
      this.state = 'form';
    },
    onSubmit() {
      // ajax送信 /////
      const siteDomain = location.hostname;
      const index = this.$store.getters.getDomains.findIndex(item => item === siteDomain);

      if (this.isSubmit) return;
      this.isSubmit = true;

      if (index > -1) {
        // multipart/form-data形式のため、new FormData()を使う
        const data = new FormData();
        data.append('mode', 'send');
        data.append('contact_type', this.contactType);
        data.append('contact_name', this.name);
        data.append('contact_email', this.email);
        data.append('contact_tel', this.tel);
        data.append('company_name', this.company1);
        data.append('company_position', this.company2);
        data.append('contact_body', this.message);
        data.append('know', this.know);
        data.append('know_search', this.know_search);
        data.append('know_how', this.know_how);

        //console.log(data);
        const pg = location.protocol + '//' + siteDomain + '/pg-contact/';
        
        axios.post(pg, data)
          .then(this.complete)
          .catch(this.onError);
      } else {
        // 開発用
        this.complete();
      }
      //////////
    },
    complete(e) {
      //this.gotoHead();
      //this.state = 'complete';
      //location.href = "";
      this.$parent.$refs['TransitionCover'].coverIn(this.compUrl);
    },
    onError(error) {
      this.isSubmit = false;
      console.log(error);
    },
    inputFocus(name) {
      this.placeholder[name] = true;
    },
    inputBlur(name) {
      if (this[name]) {
        this.placeholder[name] = true;
      } else {
        this.placeholder[name] = false;
      }
    },
    changeSelect(e) {
      if (this.contactType === 'Inquiries from overseas（海外からのお問い合わせ）') {
        this.isOverseas = true;
      } else {
        this.isOverseas = false;
      }
    },
    checkAgree() {
      if (this.isOverseas) {
        this.agree = true;
      } else {
        if (this.agree) {
          this.agree = false;
        } else {
          this.agree = true;
        }
      }

      //console.log(this.agree);
    },
    gotoHead() {
      const posY = document.getElementById('p-contactMv').getBoundingClientRect().height;

      TweenMax.to(window, 0.4, {
        scrollTo:{
          y: posY,
          autoKill: false
        },
        ease: Cubic.easeOut}
      );
    }
  }
}
</script>
